import React from 'react'
import Image from '../../../Post/modules/Image'

const InstaButtonImage: React.FC = () => {
  return (
    <>
      <Image style={{ height: '100%' }} data='/src/shared/assets/images/instagram-buttons.png' />
    </>
  )
}

export default InstaButtonImage
